import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAuthUserAction, getSaleInfoAction } from '../actions/authenAction'
import moment from 'moment'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import axios from 'axios'
import isNull from 'lodash/isNull'
import Confirm from 'buddy-glud-component/lib/Confirm'
import { clientId } from './KeycloakConfig'
import { cookieStorage, localStorage, history } from '../utils'

const PrivateRoute = ({ children }) => {

  const dispatch = useDispatch()
  const saleInfo = useSelector((state) => get(state, 'home.saleInfo', {}))

  const fullRedirectUri = window.location.href.split('?')[0]
  const getAuthUserInfo = useCallback(
    ({ children, userInfo }) => {
      dispatch(
        getAuthUserAction({
          params: `${get(
            children,
            'props.history.location.search',
            ''
          )}&channelApp=${clientId}&redirectUri=${encodeURIComponent(fullRedirectUri)}&idtoken=${get(
            saleInfo,
            'idtoken',
            ''
          )}`
        })
      )
    },
    [dispatch, fullRedirectUri, saleInfo]
  )

  const checkAppVersion = async () => {
    let version = ''
    let currentVersion = isNull(localStorage.get('salesplus-version')) ? '0.0.0' : localStorage.get('salesplus-version')
    await axios.get(`${window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')}/meta.json?ref=${moment().format('YYYYMMDDHHmmss')}`).then(res => {
      version = get(res, 'data.version', '0.0.0')

      if(version !== currentVersion) {
        Confirm.open({
          title: 'เวอร์ชั่นอัพเดท',
          content: `ระบบมีการอัพเดทเวอร์ชั่นเป็น SalesPlus-V-${version} กด ตกลง เพื่ออัพเดทเวอร์ชั่น`,
          closeButton: false,
          closeOnClickOutside: false,
          buttons: [
            {
              primary: true,
              label: 'ตกลง',
              onClick: () => {
                localStorage.set({
                  key: 'salesplus-version',
                  value: version
                })

                cookieStorage.set({ cname: 'xxopoc', cvalue: '', exdays: -1 })
                cookieStorage.set({ cname: 'SPACTIVECODE', cvalue: '', exdays: -1 })
                cookieStorage.set({ cname: 'salesPlusSaleInfo', cvalue: '', exdays: -1 })
                localStorage.remove('salesPlusMenu')

                history.push('/')
                window.location.reload('/')
              }
            }
          ]
        })
      }
    })

    if(version === currentVersion){
      if(cookieStorage.get('xxopoc') && localStorage.get('salesPlusMenu') !== null) {
        if(isEmpty(saleInfo)) {
          dispatch(getSaleInfoAction())
        }
      } else {
        if (get(children, 'props.history.location.search', '') !== '' && isEmpty(saleInfo)) {
          getAuthUserInfo({ children, saleInfo })
        }
      }
    }
  }

  useEffect(() => {
    checkAppVersion()
  })
  const isLoggedIn = !isEmpty(saleInfo)

  return isLoggedIn ? children : null
}

export default PrivateRoute
